import type { Viewport } from "src/types";

/**
 * `getViewportValue` – accepts a list of values and a `Viewport` value
 * and returns the relevant value for the specified viewport.
 * Example: given [20, 30, 40] and a viewport of "tablet", it returns 30
 */
export default function getViewportValue(
  values: [string | number, string | number, string | number],
  viewport: Viewport
) {
  if (viewport === "desktop") {
    return values[2];
  } else if (viewport === "tablet") {
    return values[1];
  } else if (viewport === "mobile") {
    return values[0];
  }
}
